import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import EditText from '../ui/EditText';
import SearchView from '../ui/SearchView';

const LibraryShelf = () => {
  const navigate = useNavigate();
  const [currentCarousel1, setCurrentCarousel1] = useState(0);
  const [currentCarousel2, setCurrentCarousel2] = useState(0);

  const books1 = [
    { id: 1, title: 'My Happy Day', cover: '/images/img_childrens_book_cover.png' },
    { id: 2, title: 'Doing Your Best', cover: '/images/img_childrens_book_cover_296x218.png' },
    { id: 3, title: 'The Purple Frog', cover: '/images/img_shelf_book.png' },
    { id: 4, title: 'Our Home', cover: '/images/img_childrens_book_cover_1.png' },
    { id: 5, title: 'About the Sky', cover: '/images/img_childrens_book_cover_2.png' },
    { id: 6, title: 'The Rabbit', cover: '/images/img_childrens_book_cover_3.png' },
    { id: 7, title: 'Book 7', cover: '/images/img_childrens_book_cover_4.png' },
    { id: 8, title: 'Book 8', cover: '/images/img_childrens_book_cover_5.png' }
  ];

  const books2 = [
    { id: 9, title: 'About the Sky', cover: '/images/img_childrens_book_cover_296x218.png' },
    { id: 10, title: 'My Happy Book', cover: '/images/img_childrens_book_cover_3.png' },
    { id: 11, title: 'Our Home', cover: '/images/img_childrens_book_cover.png' },
    { id: 12, title: 'The Rabbit', cover: '/images/img_childrens_book_cover_2.png' },
    { id: 13, title: 'My Very Best Friend', cover: '/images/img_childrens_book_cover_4.png' },
    { id: 14, title: 'The Purple Frog', cover: '/images/img_childrens_book_cover_5.png' },
    { id: 15, title: 'Book 7', cover: '/images/img_childrens_book_cover_1.png' },
    { id: 16, title: 'Book 8', cover: '/images/img_shelf_book.png' }
  ];

  const nextCarousel1 = () => {
    setCurrentCarousel1((prev) => (prev + 1) % Math.ceil(books1.length / 4));
  };

  const prevCarousel1 = () => {
    setCurrentCarousel1((prev) => (prev - 1 + Math.ceil(books1.length / 4)) % Math.ceil(books1.length / 4));
  };

  const nextCarousel2 = () => {
    setCurrentCarousel2((prev) => (prev + 1) % Math.ceil(books2.length / 4));
  };

  const prevCarousel2 = () => {
    setCurrentCarousel2((prev) => (prev - 1 + Math.ceil(books2.length / 4)) % Math.ceil(books2.length / 4));
  };

  return (
    <div className="min-h-screen bg-[#FBF5DE] relative">
      {/* Background decorative elements */}
      <div className="absolute left-0 top-0 w-14 h-full bg-gradient-to-b from-[#FBF5DE] to-[#B5A35C] rounded-full shadow-lg"></div>
      <div className="absolute right-0 top-0 w-14 h-full bg-gradient-to-b from-[#FBF5DE] to-[#B5A35C] rounded-full shadow-lg"></div>

      {/* Header */}
      <header className="bg-[#3D74B6] shadow-lg relative z-10">
        <div className="flex justify-between items-center px-20 py-10">
          {/* Navigation Buttons */}
          <div className="flex items-center gap-10">
            <div className="flex items-center gap-3 bg-[#FBF5DE] rounded-full px-8 py-3">
              <span className="text-[#374957] text-2xl font-medium">My Stories</span>
              <svg className="w-8 h-8 text-[#374957]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>

            <div className="flex items-center gap-5 border-2 border-[#FBF5DE] rounded-full px-8 py-3">
              <span className="text-[#FBF5DE] text-2xl font-medium">Level Down</span>
              <svg className="w-8 h-8 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="flex items-center gap-5 border-2 border-[#FBF5DE] rounded-full px-8 py-3">
              <span className="text-[#FBF5DE] text-2xl font-medium">Level Up</span>
              <svg className="w-8 h-8 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
          </div>

          {/* Search */}
          <SearchView
            placeholder="Search Your Library"
            value={searchValue}
            onChange={(e) => setSearchValue(e?.target?.value)}
            leftImage={{
              src: "/images/img_search.svg",
              width: 24,
              height: 24
            }}
            className="w-full sm:w-[32%]"
          />
          {/* <div className="flex items-center gap-5 bg-[#FBF5DE] rounded-full px-8 py-5 w-96">
            <svg className="w-6 h-6 text-[#374957]" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
            <span className="text-[#374957] text-2xl">Search Your Library</span>
          </div> */}
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 px-20 py-12">
        <div className="max-w-7xl mx-auto">
          {/* Gemstones Collection */}
          <div className="mb-12">
            <div className="bg-gradient-to-b from-[#FBF5DE] to-[#DED4AB] rounded-t-[100px] p-20 shadow-lg">
              <div className="grid grid-cols-3 gap-20 text-center">
                {/* Tree Image */}
                <img src="/images/img_group.svg" className="w-full sm:w-[224px] h-auto sm:h-[132px] mb-4 sm:mb-0" alt="tree" />

                {/* Emeralds */}
                <div className="flex flex-col items-center gap-3">
                  <h3 className="text-2xl font-['Cheese_Matcha'] text-[#374957]">Emeralds</h3>
                  <div className="flex items-center gap-5">
                    <div className="w-12 h-12 emerald-shadow">
                      <svg viewBox="0 0 40 40" className="w-full h-full">
                        <path d="M20 5L30 12L25 25L15 25L10 12L20 5Z" fill="#27CA40" />
                      </svg>
                    </div>
                    <span className="text-3xl font-['Cheese_Matcha'] text-[#374957]">( x3 )</span>
                  </div>
                </div>

                {/* Sapphires */}
                <div className="flex flex-col items-center gap-3">
                  <h3 className="text-2xl font-['Cheese_Matcha'] text-[#374957]">Sapphires</h3>
                  <div className="flex items-center gap-5">
                    <div className="w-12 h-12 sapphire-shadow">
                      <svg viewBox="0 0 40 40" className="w-full h-full">
                        <path d="M20 5L30 12L25 25L15 25L10 12L20 5Z" fill="#4FC3F7" />
                      </svg>
                    </div>
                    <span className="text-3xl font-['Cheese_Matcha'] text-[#374957]">( x0 )</span>
                  </div>
                </div>

                {/* Rubies */}
                <div className="flex flex-col items-center gap-3">
                  <h3 className="text-2xl font-['Cheese_Matcha'] text-[#374957]">Rubies</h3>
                  <div className="flex items-center gap-5">
                    <div className="w-12 h-12 ruby-shadow">
                      <svg viewBox="0 0 40 40" className="w-full h-full">
                        <path d="M20 5L30 12L25 25L15 25L10 12L20 5Z" fill="#FF6058" />
                      </svg>
                    </div>
                    <span className="text-3xl font-['Cheese_Matcha'] text-[#374957]">( x1 )</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#F1E9CC] text-center py-4 shadow-lg">
              <h2 className="text-2xl font-['Cheese_Matcha'] text-[#374957]">My Gemstones Collection</h2>
            </div>
          </div>

          {/* First Book Collection */}
          <div className="mb-12">
            <div className="relative">
              <div className="overflow-hidden rounded-lg mb-4">
                <div
                  className="flex transition-transform duration-300 gap-5"
                  style={{ transform: `translateX(-${currentCarousel1 * 100}%)` }}
                >
                  {books1.map((book) => (
                    <div
                      key={book.id}
                      className="flex-shrink-0 w-56 h-72 cursor-pointer transform hover:scale-105 transition-transform"
                      onClick={() => navigate('/reading-content')}
                    >
                      <img
                        src={book.cover}
                        alt={book.title}
                        className="w-full h-full object-cover rounded-lg shadow-book"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Navigation buttons */}
              <div className="flex justify-between absolute top-1/2 -translate-y-1/2 w-full px-[-75px]">
                <button
                  onClick={prevCarousel1}
                  className="w-20 h-20 bg-[#3D74B6] border-4 border-[#FBF5DE] rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                >
                  <svg className="w-10 h-10 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </button>
                <button
                  onClick={nextCarousel1}
                  className="w-20 h-20 bg-[#3D74B6] border-4 border-[#FBF5DE] rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                >
                  <svg className="w-10 h-10 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>

            <div className="bg-[#DECD8D] text-center py-4 shadow-lg">
              <h2 className="text-2xl font-['Cheese_Matcha'] text-[#374957]">My Books Collection</h2>
            </div>
          </div>

          {/* Second Book Collection */}
          <div className="mb-12">
            <div className="relative bg-gradient-to-b from-transparent to-black/50 rounded-lg p-4">
              <div className="overflow-hidden rounded-lg mb-4">
                <div
                  className="flex transition-transform duration-300 gap-5"
                  style={{ transform: `translateX(-${currentCarousel2 * 100}%)` }}
                >
                  {books2.map((book) => (
                    <div
                      key={book.id}
                      className="flex-shrink-0 w-56 h-72 cursor-pointer transform hover:scale-105 transition-transform"
                      onClick={() => navigate('/reading-content')}
                    >
                      <img
                        src={book.cover}
                        alt={book.title}
                        className="w-full h-full object-cover rounded-lg shadow-book"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Navigation buttons */}
              <div className="flex justify-between absolute top-1/2 -translate-y-1/2 w-full px-[-75px]">
                <button
                  onClick={prevCarousel2}
                  className="w-20 h-20 bg-[#3D74B6] border-4 border-[#FBF5DE] rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                >
                  <svg className="w-10 h-10 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </button>
                <button
                  onClick={nextCarousel2}
                  className="w-20 h-20 bg-[#3D74B6] border-4 border-[#FBF5DE] rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                >
                  <svg className="w-10 h-10 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Level Up Section */}
            <div className="bg-[#DECD8D] text-center py-4 shadow-lg">
              <div className="flex items-center justify-center gap-6">
                <span className="text-2xl font-['Cheese_Matcha'] text-[#3D74B6]">LEVEL UP!</span>
                <div className="flex items-center gap-3">
                  <span className="text-2xl font-['Cheese_Matcha'] text-[#374957]">Collect</span>
                  <div className="w-6 h-6">
                    <svg viewBox="0 0 25 25" className="w-full h-full">
                      <path d="M12.5 2.5L18.75 7.5L16.25 18.75L8.75 18.75L6.25 7.5L12.5 2.5Z" fill="#4FC3F7" />
                    </svg>
                  </div>
                  <span className="text-2xl font-['Cheese_Matcha'] text-[#3D74B6]">(x20)</span>
                  <span className="text-2xl font-['Cheese_Matcha'] text-[#374957]">or</span>
                  <div className="w-6 h-6">
                    <svg viewBox="0 0 25 25" className="w-full h-full">
                      <path d="M12.5 2.5L18.75 7.5L16.25 18.75L8.75 18.75L6.25 7.5L12.5 2.5Z" fill="#27CA40" />
                    </svg>
                  </div>
                  <span className="text-2xl font-['Cheese_Matcha'] text-[#3D74B6]">(x40)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-b from-transparent via-black/20 to-transparent py-8">
        <div className="text-center">
          <p className="text-white text-xl">
            Read 21 © 2025 • All Rights Reserved
          </p>
        </div>
      </footer>

      {/* Decorative side plants */}
      <div className="absolute bottom-10 left-16">
        <svg className="w-40 h-60" viewBox="0 0 160 240" fill="none">
          <path d="M80 240C80 220 60 200 40 180C60 160 80 140 80 120C80 140 100 160 120 180C100 200 80 220 80 240Z" fill="#64BF7B" />
          <path d="M80 200C80 180 100 160 120 140C100 120 80 100 80 80C80 100 60 120 40 140C60 160 80 180 80 200Z" fill="#439B7E" />
        </svg>
      </div>
      <div className="absolute bottom-10 right-16">
        <svg className="w-40 h-60" viewBox="0 0 160 240" fill="none">
          <path d="M80 240C80 220 100 200 120 180C100 160 80 140 80 120C80 140 60 160 40 180C60 200 80 220 80 240Z" fill="#64BF7B" />
          <path d="M80 200C80 180 60 160 40 140C60 120 80 100 80 80C80 100 100 120 120 140C100 160 80 180 80 200Z" fill="#439B7E" />
        </svg>
      </div>
    </div>
  );
};

export default LibraryShelf;
